"use client";

interface RecaptchaLegalNoticeProps {
  language?: string;
  className?: string;
}

/** Enterprise/v3 rozetini gizlediğimizde Google'ın zorunlu bildirimi */
export default function RecaptchaLegalNotice({ language = "en", className = "" }: RecaptchaLegalNoticeProps) {
  const isTr = language === "tr" || language.startsWith("tr");
  return (
    <p className={`text-xs text-gray-500 leading-relaxed ${className}`}>
      {isTr ? (
        <>
          Bu site reCAPTCHA ile korunmaktadır.{" "}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-alsero-first">
            Google Gizlilik Politikası
          </a>{" "}
          ve{" "}
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-alsero-first">
            Hizmet Şartları
          </a>{" "}
          geçerlidir.
        </>
      ) : (
        <>
          This site is protected by reCAPTCHA and the{" "}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-alsero-first">
            Google Privacy Policy
          </a>{" "}
          and{" "}
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-alsero-first">
            Terms of Service
          </a>{" "}
          apply.
        </>
      )}
    </p>
  );
}
